import React from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import NavBarIcon from "../../../assets/blade-runner/navbar-icon-blade-runner.webp";

const BRNavBar = () => {
  return (
    <NavDropdown title="Blade Runner" id="basic-nav-dropdown">
      <Navbar bg="dark" variant="dark" expand="md" sticky="top">
        <Navbar.Brand href="#">
          <div style={{ textAlign: "center", padding: "0px 0px 0px 8px" }}>
            The Immortality <br />
            Game
          </div>

          <small></small>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <img
              src={NavBarIcon}
              alt="Blade Runner"
              style={{ maxHeight: 85 }}
            />
          </Nav>
          <NavDropdown title="Sessions 00-10" id="basic-nav-dropdown">
            <NavDropdown.ItemText></NavDropdown.ItemText>
            <NavDropdown.Item href="/blade-runner-session-10">
              <b>10: McCoy (Case: Fiery Angels)</b> [03-27-2026]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-09">
              <b>09: Neon Mirror (Case: Fiery Angels)</b> [03-15-2026]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-08">
              <b>08: Bright Eyes (Case: Fiery Angels)</b> [03-01-2026]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-07">
              <b>07: The Leash (Case: Fiery Angels)</b> [01-23-2026]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-06">
              <b>06: Sign of the Times (Case: Electric Dreams)</b> [01-10-2026]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-05">
              <b>05: Mindkill (Case: Electric Dreams)</b> [12-19-2025]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-04">
              <b>04: Safehouse (Case: Electric Dreams)</b> [10-17-2025]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-03">
              <b>03: Memory Lab (Case: Electric Dreams)</b> [09-19-2025]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-02">
              <b>02: The Tyger (Case: Electric Dreams)</b> [08-15-2025]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-01">
              <b>01: Waking Up (Case: Electric Dreams)</b> [08-09-2025]
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-session-00">
              <b>00: Training Day</b> [03-29-2025]
            </NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Tools & Info" id="basic-nav-dropdown">
            <NavDropdown.Item href="/blade-runner-overview">
              Blade Runner Overview
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-classes">
              Blade Runner Classes
            </NavDropdown.Item>
            <NavDropdown.Item href="/blade-runner-rules">
              Blade Runner Rules
            </NavDropdown.Item>
          </NavDropdown>
        </Navbar.Collapse>
      </Navbar>
    </NavDropdown>
  );
};

export default BRNavBar;
